// test2418
(2418 && 0);
